import PasswordProtectModal from './PasswordProtectModal';

export default PasswordProtectModal;
